import { useParams, useNavigate } from "react-router-dom";
import { Tabs, FloatingSaveBar } from "#common";
import PrimaryInformation from "./primary_information";
import IntakeInformation from "./intake_information";
import MedicalHistory from "./medical_history";
import AnimalHeader from "./animal_header";
import AddItem from "./add_item";
import Upcoming from "./upcoming";
import { useApiState } from "#hooks";
import { IconArrowLeft } from "@tabler/icons-react";

function Animal() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { state, onChange, isChanged, submit, reset } = useApiState(
    `/animal/${id}`,
    `/animal/${id}`,
  );
  const sectionTabs = [
    {
      name: "Primary Information",
      key: "PRIMARY",
      component: <PrimaryInformation animal={state} onChange={onChange} />,
    },
    {
      name: "Intake Information",
      key: "INTAKE",
      component: <IntakeInformation />,
    },
    {
      name: "Medical History",
      key: "MEDICAL",
      component: <MedicalHistory records={state.medicalRecords} />,
    },
  ];
  return (
    <div className="pb-24">
      <button onClick={() => navigate(-1)} className="p-4">
        <IconArrowLeft />
      </button>
      <AnimalHeader animal={state} />
      <AddItem animal={state} />
      <Upcoming animal={state} />
      <Tabs tabs={sectionTabs} defaultValue={sectionTabs[0].key}></Tabs>
      <FloatingSaveBar isChanged={isChanged} reset={reset} submit={submit} />
    </div>
  );
}
export default Animal;
